import { useEffect } from "react";
import { installOverflowTooltipListeners } from "../lib/overflowTooltip";

export function OverflowTooltipProvider({ children }) {
  useEffect(() => installOverflowTooltipListeners(document), []);

  return children;
}
